import React from "react";

function Contactus() {
  return <div>Contact page</div>;
}

export default Contactus;
